import CompanyVisionCard from "@components/BasicComponents/Cards/CompanyVisionCard/CompanyVisionCard"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import ContentAssetSwitcher from "@components/WebsiteRevamp/Switchers/ContentAssetSwitcher/ContentAssetSwitcher"
import {Size} from "@components/WebsiteRevamp/Typography/Typography"
import {
	AdvancedSideAssetMainContent,
	AdvancedSideAssetModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import CompanyCountsSection from "../CompanyCountsSection/CompanyCountsSection"

import styles from "./CompanyIntroSection.module.scss"

type Props = {
	intro: AdvancedSideAssetModuleType
	data: AdvancedSideAssetModuleType
	counts: AdvancedSideAssetModuleType
}

const CompanyIntroSection = (props: Props) => {
	return (
		<section>
			<ContainerWrapper>
				<Separator size={128}>
					<ContentAssetSwitcher
						contentAssetProps={{
							withAspectRation: false,
						}}
						data={props.intro}
					/>
					<Separator size={128}>
						<CompanyCountsSection
							data={props.counts}
							withoutAsset
						/>
					</Separator>

					<div className={styles.cardContainer}>
						{props.data.mainContent?.map(
							(
								element: AdvancedSideAssetMainContent,
								index: number,
							) => {
								return (
									<CompanyVisionCard
										key={index}
										className={styles.cardBox}
										data={element}
										size={Size.L}
									/>
								)
							},
						)}
					</div>
				</Separator>
			</ContainerWrapper>
		</section>
	)
}

export default CompanyIntroSection
